import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=7236f93b"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=7236f93b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports